import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const TravelProfileCard = ({ context, isCollapsed = false, onToggle, canEdit = true }) => {
  const navigate = useNavigate();
  const { interviewId: interviewIdParam, itineraryId } = useParams();
  const interviewId = interviewIdParam || itineraryId;

  if (!context || !interviewId) {
    return null;
  }

  return (
    <div className="glass-card rounded-lg p-6">
      <div className="flex items-center justify-between mb-4 gap-3">
        {typeof onToggle === 'function' ? (
          <button
            type="button"
            onClick={onToggle}
            aria-expanded={!isCollapsed}
            aria-label={`${isCollapsed ? 'Expand' : 'Collapse'} travel profile details`}
            className="group flex items-center gap-2 text-left text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/60 rounded"
          >
            <span className="inline-flex items-center justify-center p-1.5 rounded-full bg-emerald-500/15 text-emerald-300 transition-colors duration-200 group-hover:bg-emerald-500/25 group-hover:text-emerald-200">
              <svg
                className={`w-5 h-5 transform transition-transform duration-200 ${isCollapsed ? '' : 'rotate-90'}`}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 6l6 6-6 6" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <span className="text-xl md:text-2xl font-bold">Your Travel Profile</span>
          </button>
        ) : (
          <h3 className="text-xl md:text-2xl font-bold text-white">Your Travel Profile</h3>
        )}
        {canEdit && (
          <button 
            type="button"
            onClick={() => navigate(`/interview/review/${interviewId}`)}
            className="text-xs text-emerald-300 hover:text-emerald-200 transition-colors"
          >
            Edit interview answers
          </button>
        )}
      </div>
      <div>
        <div className="space-y-2 text-sm text-white">
          <div><span className="font-bold">Party:</span> <span>{context.party}</span></div>
          <div><span className="font-bold">Dates:</span> <span>{context.dates}</span></div>
          <div><span className="font-bold">Home Base:</span> <span>{context.homebase}</span></div>
          {!isCollapsed && context.partyInsights && (
            <div className="mt-3 pt-3 border-t border-white/10">
              <span className="font-bold">Group Dynamics:</span>
              <div className="mt-1 leading-relaxed">{context.partyInsights}</div>
            </div>
          )}
          {!isCollapsed && context.preferences && (
            <div className="mt-3 pt-3 border-t border-white/10">
              <span className="font-bold">Trip Context:</span>
              <div className="mt-1 leading-relaxed">{context.preferences}</div>
            </div>
          )}
          {!isCollapsed && context.specialConsiderations && (
            <div className="mt-3 pt-3 border-t border-white/10">
              <span className="font-bold">Special Considerations:</span>
              <div className="mt-1">{context.specialConsiderations}</div>
            </div>
          )}
        </div>
        {isCollapsed && (context.partyInsights || context.preferences || context.specialConsiderations) && (
          <p className="mt-3 text-xs text-white/60 italic">
            Group dynamics, trip context, and special considerations are hidden in this condensed view.
          </p>
        )}
      </div>
    </div>
  );
};

export default TravelProfileCard;
